import { SearchCriteriaQuerySentimentsEnum } from '../../../api/mentions/enum/search-criteria-query-sentiments.enum';


export const socialSentimentToSearchCriteriaQuerySentimentsEnumMap = new Map<string, SearchCriteriaQuerySentimentsEnum>([
    [ 'positive',     SearchCriteriaQuerySentimentsEnum.positive     ],
    [ 'negative',     SearchCriteriaQuerySentimentsEnum.negative     ],
    [ 'neutral',      SearchCriteriaQuerySentimentsEnum.neutral      ],
    [ 'notAvailable', SearchCriteriaQuerySentimentsEnum.notAvailable ]
]);
